import { Button, Card, Stack, Typography } from "@mui/joy";
import React, { useState } from "react";
import PersonCard from "./PersonCard";
import wedding_party from "Data/WeddingParty";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function WeddingPartyDisplay() {
    const isMobile = useMediaQuery('(max-width:600px)');
    const main_party_size = 320;
    const smaller_party_size = 200;
    const [partyView, setPartyView] = useState(0);

    const nextView = () => {
        setPartyView((prev) => (prev + 1) % 3); // Cycle through views
    };

    const prevView = () => {
        setPartyView((prev) => (prev - 1 + 3) % 3); // Cycle backwards
    };

    return (
        <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: "#BF5B05", border: "none", position: 'relative', padding: 2 }}>
            <Button sx={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)' }} onClick={prevView}>
                <ArrowBackIcon />
            </Button>



            {partyView === 0 && (
                <>
                    <Typography level="h1" sx={{ textAlign: 'center' }}>
                        The Wedding Party
                    </Typography>
                    <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ justifyContent: 'center' }}>
                        <PersonCard person={wedding_party.tala} size={main_party_size} />
                        <PersonCard person={wedding_party.david} size={main_party_size} />
                        <PersonCard person={wedding_party.abby} size={main_party_size} />
                        <PersonCard person={wedding_party.dan} size={main_party_size} />
                    </Stack>
                </>
            )}

            {partyView === 1 && (
                <>
                    <Typography level="h1" sx={{ textAlign: 'center' }}>
                        The Bridesmaids
                    </Typography>
                    <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ justifyContent: 'center' }}>
                        <PersonCard person={wedding_party.lauren_walker} size={smaller_party_size} />
                        <PersonCard person={wedding_party.morgan_vasas} size={smaller_party_size} />
                        <PersonCard person={wedding_party.ceecee_darmes} size={smaller_party_size} />
                        <PersonCard person={wedding_party.tori_wing} size={smaller_party_size} />
                    </Stack>

                </>
            )}

            {partyView === 2 && (
                <>
                    <Typography level="h1" sx={{ textAlign: 'center' }}>
                        The Groomsmen
                    </Typography>
                    <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ justifyContent: 'center' }}>
                        <PersonCard person={wedding_party.alex_wing} size={smaller_party_size} />
                        <PersonCard person={wedding_party.michael_ashbrook} size={smaller_party_size} />
                        <PersonCard person={wedding_party.bobby} size={smaller_party_size} />
                        <PersonCard person={wedding_party.kyle_moran} size={smaller_party_size} />
                        <PersonCard person={wedding_party.niksa} size={smaller_party_size} />
                        <PersonCard person={wedding_party.callan} size={smaller_party_size} />
                    </Stack>
                </>
            )}

            <Button sx={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)' }} onClick={nextView}>
                <ArrowForwardIcon />
            </Button>
        </Card>
    );
}

export default WeddingPartyDisplay;